<template>
  <section id="projects" class="projects">
    <h2 class="projects_title">Projects</h2>
    <p class="projects_bio">These are some of the projects I have worked on.</p>

    <div class="entire_tags_section">
        <img class="arrow_button" @click="scrollLeft" src="../assets/backwards_arrow.png" alt="Bacwards Icon" />

        <div class="tags_section" ref="scrollRow">
            <div class="tag_loop" v-for="(tag, index) in tags" v-bind:key="index" @click="onSelectTag(tag)" >
                <p :class="(selectedTag === tag ? 'selected_tag' : 'tag_text')">{{ tag === 'css' || tag === 'html' ? tag.toUpperCase() : tag.charAt(0).toUpperCase() + tag.slice(1) }}</p>
            </div>
        </div>

        <img class="arrow_button" @click="scrollRight" src="../assets/forward_arrow.png" alt="Forward Icon" />
    </div>

    <div class="loop_body" v-for="(project, index) in projects" v-bind:key="index">
        <div :class="'project_sect_' + project.type" :style="'flex-direction: ' + (screenWidth > 768 ? (project.type === 'b' ? 'row-reverse' : 'row') : 'column') + ';margin-bottom: ' + (screenWidth > 768 ? (index < projects.length - 1 ? '200px' : '50px') : '100px')">
            <div :class="(project.type === 'a' ? 'project_sect_column_a' : 'project_sect_column_b')">
                <p :class="(project.type === 'a' ? 'project_type_a' : 'project_type_b')">{{ project.app.charAt(0).toUpperCase() + project.app.slice(1) }} Application</p>
                <p :class="(project.type === 'a' ? 'project_name_a' : 'project_name_b')" :style="'color: ' + project.color">{{ project.title }}</p>
                <p :class="(project.type === 'a' ? 'project_description_a' : 'project_description_b')" :style="'background-color: ' + project.textBackgroundColor">
                    {{ project.description }}
                    <br>
                    <br>
                    {{ 
                        project.tags
                        .filter(item => item !== "web" && item !== "mobile")
                        .map(tag => tag.charAt(0).toUpperCase() + tag.slice(1))
                        .join(', ') 
                    }}
                </p>
                <div :class="(project.type === 'a' ? 'project_sect_icons_a' : 'project_sect_icons_b')">
                    <a class="project_icon_link" v-if="project.instagram != null" :href="project.instagram" target="_blank"><img class="project_icon" :src="project.instagramIcon" :alt="project.instagramAlt" /></a>
                    <a class="project_icon_link" :href="project.link" target="_blank"><img class="project_icon" :src="project.icon" :alt="project.viewAlt" /></a>
                </div>
            </div>

            <!-- <div :class="(project.type === 'a' ? 'project_image_con_a' : 'project_image_con_b')" :style="'background-color: ' + project.imageBackgroundColor + '; height: ' + (project.app == 'mobile' ? '300px' : '') + '; width: ' + (project.app == 'mobile' ? '180px' : 'max-content') + 'align-self: ' + (project.type === 'b' ? 'flex-end' : 'flex-start') + ';'">
                <img class="project_image" :style="'height: ' + (project.app == 'mobile' ? '300px' : '') + '; width: ' + (project.app == 'mobile' ? (index === projects.length - 1 && project.title === 'Noughts and Crosses Mobile' ? '350px' : '180px') : '') + ';'" :src="project.image" :alt="project.imageAlt" />
            </div> -->

            <div :class="(project.type === 'a' ? (screenWidth > 768 ? 'project_image_con_a' : 'project_image_con_a_mobile') : (screenWidth > 768 ? 'project_image_con_b' : 'project_image_con_b_mobile'))" :style="'background-color: ' + project.imageBackgroundColor + '; align-self: ' + (project.type === 'b' ? 'flex-end' : 'flex-start') + ';'">
                <img :class="(project.app == 'web' ? 'project_image' : (project.title === 'Noughts and Crosses Mobile' ? 'project_image_mobile_2' : 'project_image_mobile'))" :src="project.image" :alt="project.imageAlt" />
            </div>
        </div>
    </div>

    <!-- <div class="project_sect_a">
        <div class="project_sect_column_a">
            <p class="project_type_a">Web Application</p>
            <p class="project_name_a" style="color: aliceblue;">Movinity</p>
            <p class="project_description_a" style="background-color: rgb(3, 19, 42, 0.7)">
                Discover and explore movies and TV shows. Join a community of cinema enthusaits build and share your watchlist, rate and 
                review your favorite films, and connect with like-minded individuals.
                <br>
                <br>
                React.js, CSS, Firebase, Vercel
            </p>
            <div class="project_sect_icons_a">
                <a class="project_icon_link" href="https://www.instagram.com/themovinityplace/" target="_blank"><img class="project_icon" src="../assets/instagram_icon_2.png" alt="Instgram" /></a>
                <a class="project_icon_link" href="https://movinity-web.vercel.app/" target="_blank"><img class="project_icon" src="../assets/view_aliceblue.png" alt="Instgram" /></a>
            </div>
        </div>

        <div class="project_image_con_a" style="background-color: rgb(10, 35, 81, 0.8);">
            <img class="project_image" src="../assets/movinity_image.png" alt="Movinity Image" />
        </div>
    </div>

    <div class="project_sect_b">
        <div class="project_image_con_b" style="background-color: rgb(255, 126, 95, 0.8);">
            <img class="project_image" src="../assets/noughts_and_crosses_web.png" alt="Noughts and Crosses Image" />
        </div>

        <div class="project_sect_column_b">
            <p class="project_type_b">Web Application</p>
            <p class="project_name_b" style="color: #feb47b;">Noughts and Crosses</p>
            <p class="project_description_b" style="background-color: rgb(82, 39, 29, 0.7)">
                Enjoy the timeless game of Tic-Tac-Toe. Play against friends or challenge the AI in this simple yet fun game.
                <br>
                <br>
                HTML, CSS, JavaScript, Firebase, Vercel
            </p>
            <div class="project_sect_icons_b">
                <a class="project_icon_link" href="https://noughts-and-crosses-web-application.vercel.app/" target="_blank"><img class="project_icon" src="../assets/view_brown.png" alt="Instgram" /></a>
            </div>
        </div>
    </div>

    <div class="project_sect_a">
        <div class="project_sect_column_a">
            <p class="project_type_a">Mobile Application</p>
            <p class="project_name_a" style="color: aliceblue;">Country Search</p>
            <p class="project_description_a" style="background-color: rgb(57, 57, 57, 0.8)">
                Easily explore interesting facts about various countries. Search for countries, view their details, and learn about their cultures and histories.
                <br>
                <br>
                Flutter, Dart, Firebase
            </p>
            <div class="project_sect_icons_a">
                <a class="project_icon_link" href="https://drive.google.com/file/d/10RGyhlfDTxfYRn2G4OM4MxfUPUwotCFQ/view?usp=drive_link" target="_blank"><img class="project_icon" src="../assets/download_aliceblue.png" alt="Instgram" /></a>
            </div>
        </div>

        <div class="project_image_con_a" style="background-color: rgb(165, 165, 165, 0.8); align-self: flex-start;">
            <img class="project_image" style="height: 300px; width: 180px;" src="../assets/country_search.png" alt="Country Search Image" />
        </div>
    </div>

    <div class="project_sect_b">
        <div class="project_image_con_b" style="background-color: rgb(102, 153, 204, 0.8); align-self: flex-end;">
            <img class="project_image" style="height: 300px; width: 180px;" src="../assets/quotes_app.png" alt="Quotes Image" />
        </div>

        <div class="project_sect_column_b">
            <p class="project_type_b">Mobile Application</p>
            <p class="project_name_b" style="color: #4B9CD3;">Quotes</p>
            <p class="project_description_b" style="background-color: rgb(0, 102, 178, 0.8)">
                Find inspiring quotes for any occasion and get daily motivation. Search for quotes by author or topic, and create your 
                own account.
                <br>
                <br>
                Flutter, Dart, Firebase
            </p>
            <div class="project_sect_icons_b">
                <a class="project_icon_link" href="https://drive.google.com/file/d/1YKVnUeEJCO4EEtn_pgjRd1q3evwSfcg8/view?usp=drive_link" target="_blank"><img class="project_icon" src="../assets/download_blue.png" alt="Instgram" /></a>
            </div>
        </div>
    </div>

    <div class="project_sect_a">
        <div class="project_sect_column_a">
            <p class="project_type_a">Mobile Application</p>
            <p class="project_name_a" style="color: aliceblue;">Encryption Application</p>
            <p class="project_description_a" style="background-color: rgb(3, 16, 114, 0.8)">
                Easily encrypt your sensitive data and ensure its security with the help of this powerful and user-friendly application.
                <br>
                <br>
                Flutter, Dart, Firebase
            </p>
            <div class="project_sect_icons_a">
                <a class="project_icon_link" href="https://movinity-web.vercel.app/" target="_blank"><img class="project_icon" src="../assets/download_aliceblue.png" alt="Instgram" /></a>
            </div>
        </div>

        <div class="project_image_con_a" style="background-color: rgb(3, 58, 114, 0.8); align-self: flex-start;">
            <img class="project_image" style="height: 300px; width: 180px;" src="../assets/encryption_app.png" alt="Country Search Image" />
        </div>
    </div>

    <div class="project_sect_b" style="margin-bottom: 50px;">
        <div class="project_image_con_b" style="background-color: rgb(86, 86, 86, 0.8); align-self: flex-end;">
            <img class="project_image" style="height: 300px; width: 300px;" src="../assets/noughts_and_crosses_mobile.png" alt="Noughts and Crosses Image" />
        </div>

        <div class="project_sect_column_b">
            <p class="project_type_b">Mobile Application</p>
            <p class="project_name_b" style="color: #6699CC;">Noughts and Crosses</p>
            <p class="project_description_b" style="background-color: rgb(46, 46, 46, 0.7)">
                Enjoy the classic game of Tic-Tac-Toe. Challenge your friends for fun matches or test your skills against a 
                smart AI opponent!
                <br>
                <br>
                Kotlin, Firebase
            </p>
            <div class="project_sect_icons_b">
                <a class="project_icon_link" href="https://drive.google.com/file/d/1Wv1TWmc8bk7_Egt7N8Ckz271ih0BxDMM/view?usp=sharing" target="_blank"><img class="project_icon" src="../assets/download_blue_2.png" alt="Download" /></a>
            </div>
        </div>
    </div> -->
  </section>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue';

export default {
  setup() {
      const selectedTag = ref('all');
      const screenWidth = ref(window.innerWidth);
      const scrollRow = ref(null);

      const scrollLeft = () => {
        if (scrollRow.value) {
            scrollRow.value.scrollBy({ left: -200, behavior: 'smooth' });
        }

        // scrollRow.value.scrollLeft -= 200;
      };

      const scrollRight = () => {
        if (scrollRow.value) {
            scrollRow.value.scrollBy({ left: 200, behavior: 'smooth' });
        }

        // scrollRow.value.scrollLeft += 200;
      };

      const handleResize = () => {
        screenWidth.value = window.innerWidth;
      };

      onMounted(() => {
        window.addEventListener('resize', handleResize);
      });

      onUnmounted(() => {
        window.removeEventListener('resize', handleResize);
      });

      const tags = [
        'all',
        'web',
        'mobile',
        'react.js',
        'css',
        'firebase',
        'vercel',
        'html',
        'javascript',
        'flutter',
        'dart',
        'kotlin'
      ];

      const originalProjects = [
        {
          title: 'Movinity',
          type: 'a',
          app: 'web',
          description: 'Discover and explore movies and TV shows. Join a community of cinema enthusaits build and share your watchlist, rate and review your favorite films, and connect with like-minded individuals.',
          image: require('@/assets/movinity_image.png'),
          link: 'https://movinity.ifechukwunwachukwu.com/',
          icon: require('@/assets/view_aliceblue.png'),
          instagram: 'https://www.instagram.com/themovinityplace/',
          instagramIcon: require('@/assets/instagram_icon_2.png'),
          tags: ['react.js', 'css', 'firebase', 'vercel', 'web'],
          color: 'aliceblue',
          textBackgroundColor: 'rgb(3, 19, 42, 0.7)',
          imageBackgroundColor: 'rgb(10, 35, 81, 0.8)',
          imageAlt: 'Movinity Image',
          instagramAlt: 'Instagram Icon',
          viewAlt: 'View Icon',
        },
        {
          title: 'Character Match',
          type: 'b',
          app: 'web',
          description: 'Match emojis, letters, numbers, or animals. Test your memory and see how fast you can find all the pairs!',
          image: require('@/assets/character_match_image.png'),
          link: 'https://character-match.ifechukwunwachukwu.com/',
          icon: require('@/assets/view_plum.png'),
          tags: ['react.js', 'css', 'vercel', 'web'],
          color: 'plum',
          textBackgroundColor: 'rgb(65, 0, 65, 0.8)',
          imageBackgroundColor: 'rgb(128, 0, 128, 0.5)',
          imageAlt: 'Character Match Image',
          viewAlt: 'View Icon',
        },
        {
          title: 'Noughts and Crosses',
          type: 'a',
          app: 'web',
          description: 'Enjoy the timeless game of Tic-Tac-Toe. Play against friends or challenge the AI in this simple yet fun game.',
          image: require('@/assets/noughts_and_crosses_web.png'),
          link: 'https://noughts-and-crosses.ifechukwunwachukwu.com/',
          icon: require('@/assets/view_brown.png'),
          tags: ['html', 'css', 'javascript', 'firebase', 'vercel', 'web'],
          color: '#feb47b',
          textBackgroundColor: 'rgb(82, 39, 29, 0.7)',
          imageBackgroundColor: 'rgb(255, 126, 95, 0.8)',
          imageAlt: 'Noughts and Crosses Image',
          viewAlt: 'View Icon',
        },
        {
          title: 'Country Search',
          type: 'b',
          app: 'mobile',
          description: 'Easily explore interesting facts about various countries. Search for countries, view their details, and learn about their cultures and histories.',
          image: require('@/assets/country_search.png'),
          link: 'https://drive.google.com/file/d/10RGyhlfDTxfYRn2G4OM4MxfUPUwotCFQ/view?usp=drive_link',
          icon: require('@/assets/download_aliceblue.png'),
          tags: ['flutter', 'dart', 'firebase', 'mobile'],
          color: 'aliceblue',
          textBackgroundColor: 'rgb(57, 57, 57, 0.8)',
          imageBackgroundColor: 'rgb(165, 165, 165, 0.8)',
          imageAlt: 'Country Search Image',
          viewAlt: 'Download Icon',
        },
        {
          title: 'Quotes',
          type: 'a',
          app: 'mobile',
          description: 'Find inspiring quotes for any occasion and get daily motivation. Search for quotes by author or topic, and create your own account.',
          image: require('@/assets/quotes_app.png'),
          link: 'https://drive.google.com/file/d/1YKVnUeEJCO4EEtn_pgjRd1q3evwSfcg8/view?usp=drive_link',
          icon: require('@/assets/download_blue.png'),
          tags: ['flutter', 'dart', 'firebase', 'mobile'],
          color: '#4B9CD3',
          textBackgroundColor: 'rgb(0, 102, 178, 0.8)',
          imageBackgroundColor: 'rgb(102, 153, 204, 0.8)',
          imageAlt: 'Quotes Image',
          viewAlt: 'Download Icon',
        },
        {
          title: 'Encryption Application',
          type: 'b',
          app: 'mobile',
          description: 'Easily encrypt your sensitive data and ensure its security with the help of this powerful and user-friendly application.',
          image: require('@/assets/encryption_app.png'),
          link: 'https://movinity-web.vercel.app/',
          icon: require('@/assets/download_aliceblue.png'),
          tags: ['flutter', 'dart', 'firebase', 'mobile'],
          color: 'aliceblue',
          textBackgroundColor: 'rgb(3, 16, 114, 0.8)',
          imageBackgroundColor: 'rgb(3, 58, 114, 0.8)',
          imageAlt: 'Encryption App Image',
          viewAlt: 'Download Icon',
        },
        {
          title: 'Noughts and Crosses Mobile',
          type: 'a',
          app: 'mobile',
          description: 'Enjoy the classic game of Tic-Tac-Toe. Challenge your friends for fun matches or test your skills against a smart AI opponent!',
          image: require('@/assets/noughts_and_crosses_mobile.png'),
          link: 'https://drive.google.com/file/d/1Wv1TWmc8bk7_Egt7N8Ckz271ih0BxDMM/view?usp=sharing',
          icon: require('@/assets/download_blue_2.png'),
          tags: ['kotlin', 'firebase', 'mobile'],
          color: '#6699CC',
          textBackgroundColor: 'rgb(46, 46, 46, 0.7)',
          imageBackgroundColor: 'rgb(86, 86, 86, 0.8)',
          imageAlt: 'Noughts and Crosses Mobile Image',
          viewAlt: 'Download Icon',
        }
      ];

      const projects = ref([]);

      onMounted(() => {
        projects.value = originalProjects;
      });

      const onSelectTag = (tag) =>{
        selectedTag.value = tag;
        if (tag === 'all') {
          projects.value = originalProjects;
        } else {
          projects.value = originalProjects.filter(project => project.tags.includes(tag));
        }
      }

      return {
        selectedTag,
        tags,
        projects,
        onSelectTag,
        scrollLeft,
        scrollRight,
        scrollRow,
        screenWidth,
     };
  },
}
</script>

<style scoped>
    .projects {
        height: 100%;
        width: 100%;
        padding-top: 100px;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start ;
        /* color: rgb(46, 46, 46); */
        color: brown;
        /* background-color: rgb(0, 0, 0, 0.8); */
        /* border-bottom: 3px solid rgb(73, 2, 46, 0.5); */
    }

    .projects_title {
        font-size: 42px;
        font-weight: 700;
        color: rgb(150, 8, 96);
        width: 80%;
    }

    .projects_bio{
        font-size: 24px;
        color: #A5A5A5;
        margin-top: 20px;
        margin-bottom: 30px;
        width: 80%;
    }

    .entire_tags_section{
        width: 80%;
        /* position: relative; */
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        gap: 20px;
        margin-bottom: 100px;
        overflow-x: hidden;
    }

    .arrow_button{
        width: 35px;
        height: 35px;
        cursor: pointer;
        transition: transform 0.3s ease;
        flex-shrink: 0;
    }

    .tags_section{
        flex: 1;
        display: flex;
        flex-direction: row;
        align-items: center;
        /* justify-content: space-between; */
        gap: 10px;
        overflow-x: auto;
        scroll-behavior: smooth;
        scrollbar-width: none;
        -ms-overflow-style: none;
    }

    .tags_section::-webkit-scrollbar {
        display: none;
    }

    .tag_loop{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }

    .tag_text, .selected_tag{
        font-size: 18px;
        /* color: rgb(79, 77, 79); */
        color: plum;
        /* background-color: black; */
        font-weight: 600;
        padding: 10px 20px;
        border-radius: 10px;
        cursor: pointer;
        transition: background-color 0.1s ease, color 0.1s ease;
    }

    .selected_tag{
        background-color: black;
        color: #A5A5A5;
    }

    .loop_body{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .project_sect_a, .project_sect_b{
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        margin-bottom: 200px;
        position: relative;
    }

    .project_sect_column_a{
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: start;
        position: relative;
        margin-left: 7%;
        z-index: 2;
        top: 0;
        left: 3%;
    }

    .project_sect_column_b{
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: start;
        position: relative;
        margin-right: 7%;
        z-index: 2;
        top: 0;
        right: 3%;
    }

    .project_type_a{
        font-size: 18px;
        color: #A5A5A5;
        font-weight: 600;
    }

    .project_name_a{
        font-size: 32px;
        font-weight: 700;
        /* color: aliceblue; */
        margin-top: 5px;
    }

    .project_type_b{
        font-size: 18px;
        color: #A5A5A5;
        font-weight: 600;
        text-align: right;
        width: 100%;
    }

    .project_name_b{
        font-size: 32px;
        font-weight: 700;
        /* color: aliceblue; */
        margin-top: 5px;
        text-align: right;
        width: 100%;
    }

    .project_description_a{
        font-size: 18px;
        color: #A5A5A5;
        margin-top: 30px;
        text-align: left;
        padding-top: 25px;
        padding-bottom: 25px;
        padding-left: 25px;
        padding-right: 60px;
        border-radius: 20px;
        /* background-color: rgb(3, 19, 42, 0.7); */
    }

    .project_description_b{
        font-size: 18px;
        color: #A5A5A5;
        margin-top: 30px;
        text-align: right;
        padding-top: 25px;
        padding-bottom: 25px;
        padding-right: 25px;
        padding-left: 60px;
        border-radius: 20px;
        /* background-color: linear-gradient(to right, #ff7e5f, #feb47b); */
    }

    .project_sect_icons_a{
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 20px;
        margin-top: 30px;
    }

    .project_sect_icons_b{
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 20px;
        margin-top: 30px;
        align-self: flex-end;
    }

    .project_icon{
        width: 30px;
        height: 30px;
        object-fit: cover;
        transition: transform 0.3s ease;
        cursor: pointer;
    }

    .project_icon_link{
        text-decoration: none;
    }

    .project_image_con_a, .project_image_con_a_mobile{
        flex: 1;
        /* width: max-content; */
        /* height: 100%; */
        padding-left: 20px;
        padding-top: 20px;
        border-radius: 15px;
        /* background-color: rgb(10, 35, 81, 0.8); */
        position: relative;
        z-index: 1;
        margin-right: 10%;
    }

    .project_image_con_b, .project_image_con_b_mobile{
        flex: 1;
        /* width: max-content; */
        /* height: 100%; */
        padding-right: 20px;
        padding-top: 20px;
        border-radius: 15px;
        /* background-color: rgb(10, 35, 81, 0.8); */
        position: relative;
        z-index: 1;
        margin-left: 10%;
    }

    .project_image_con_a_mobile, .project_image_con_b_mobile{
        width: 180px;
        height: 300px;
    }

    .project_image{
        width: 100%;
        height: 100%;
    }

    .project_image_mobile{
        width: 180px;
        height: 300px;
    }

    .project_image_mobile_2{
        width: 350px;
        height: 300px;
    }

    @media (max-width: 1200px) {

        .project_sect_a, .project_sect_b {
            margin-bottom: 100px;
        }
        
    }

    @media (max-width: 768px) {
        .projects {
            width: 80vw;
        }

        .projects_title {
            font-size: 32px;
            /* width: 100%; */
        }

        .projects_bio {
            font-size: 18px;
            width: 80vw;
            margin-top: 10px;
        }

        .project_sect_a{
            flex-direction: column;
            align-items: center;
            width: 100%;
            margin-bottom: 100px;
            position: relative;
        }

        .project_sect_b{
            flex-direction: column-reverse;
            align-items: center;
            width: 100%;
            margin-bottom: 100px;
            position: relative;
        }

        .project_sect_column_a{
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: start;
            position: relative;
            margin-left: 0;
            z-index: 2;
            top: 0;
            left: 0;
        }

        .project_sect_column_b{
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: start;
            position: relative;
            margin-right: 0;
            z-index: 2;
            top: 0;
            right: 0;
        }

        .project_type_a{
            font-size: 16px;
        }

        .project_name_a{
            font-size: 26px;
            font-weight: 700;
            /* color: aliceblue; */
            margin-top: 5px;
        }

        .project_type_b{
            font-size: 16px;
        }

        .project_name_b{
            font-size: 26px;
        }

        .project_description_a{
            font-size: 16px;
            margin-top: 10px;
            text-align: left;
            padding-top: 10px;
            padding-bottom: 10px;
            padding-left: 10px;
            padding-right: 10px;
            border-radius: 15px;
        }

        .project_description_b{
            font-size: 18px;
            color: #A5A5A5;
            margin-top: 30px;
            text-align: right;
            padding-top: 10px;
            padding-bottom: 10px;
            padding-right: 10px;
            padding-left: 10px;
            border-radius: 15px;
        }

        .project_sect_icons_a{
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 10px;
            margin-top: 10px;
            margin-bottom: 10px;
        }

        .project_sect_icons_b{
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 10px;
            margin-top: 10px;
            margin-bottom: 10px;
            align-self: flex-end;
        }

        .project_icon{
            width: 20px;
            height: 20px;
        }

        .project_image_con_a, .project_image_con_a_mobile{
            flex: 1;
            width: max-content;
            height: 100px;
            padding-left: 0;
            padding-right: 10px;
            padding-top: 10px;
            border-radius: 10px;
            position: relative;
            z-index: 1;
            margin-right: 0;
        }

        .project_image_con_b, .project_image_con_b_mobile{
            flex: 1;
            width: max-content;
            height: 100px;
            padding-right: 0;
            padding-left: 10px;
            padding-top: 10px;
            border-radius: 10px;
            position: relative;
            z-index: 1;
            margin-left: 0;
        }

        .project_image_con_a_mobile, .project_image_con_b_mobile{
            width: max-content;
            height: max-content;
        }

        .project_image{
            width: 80vw;
            height: 200px;
        }

        .project_image_mobile{
            width: 130px;
            height: 200px;
        }

        .project_image_mobile_2{
            width: 250px;
            height: 200px;
        }

        .entire_tags_section{
            width: 100%;
            gap: 10px;
            margin-bottom: 50px;
        }

        .arrow_button{
            width: 25px;
            height: 25px;
        }

        .tags_section{
            gap: 1px;
        }

        .tag_text, .selected_tag{
            font-size: 16px;
            font-weight: 600;
        }

        .loop_body{
            width: 100%;
        }
    }
</style>
